import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_TOTAL_QS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal } from './types'

import type { ReportEntity } from '../../drilldown/types'

type DrillDownCustomer = ReportEntity & {
  customerId: number
  customerName: string
  customerOrgNo: string
  customerHeadId: number
  customerHeadName: string
  customerHeadFrameAgreementId: number
  customerHeadFrameAgreementName: string
}

const IS_NEW_BACKEND_API = true

export const getDrillDownCustomerTotals = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const customerList = await get<DrillDownCustomer[]>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_TOTAL_QS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return customerList
}
